export default function isWithinOneYear(date1, date2) {
	const timeDifference = Math.abs(date2 - date1);
	const daysDifference = timeDifference / (1000 * 60 * 60 * 24);
	return daysDifference <= 365; // Assuming a year has 365 days
}